module.exports = {
      id: "slider-left-arrow-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "svg-sprite-39dbc991ee8a2ec1b35aeef6495011e2.svg#slider-left-arrow",
      toString: function () {
        return this.url;
      }
    }